import axios from "axios";

export default {
    doEditAddressTemp(obj) {
        return axios.post("/course/Usercenter/doEditAddressTemp", obj);
    },
    getMyAddressTemp(obj) {
        return axios.post("/course/Usercenter/getMyAddressTemp", obj);
    }
}